import Vue from 'vue'
import './css/_reset.css'
import './css/_common.less'
import '../src/font/font-awesome/css/font-awesome.min.css'
import './plugins/axios'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import App from './App.vue'
import 'mint-ui/lib/style.css'
import VueMessage from './components/language'
// import './i18n/index'
import cookie from 'js-cookie';
import VueI18n from 'vue-i18n'

window.$cookie = cookie;
Vue.prototype.$cookie = cookie;
Vue.use(VueMessage)
Vue.use(MintUI)
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.directive('omnisdk_open', {
  bind: function (el) {
    el.addEventListener('click', function (e) {
      if (window._omnisdk) {
        e.preventDefault();
        // 调用sdk bridge打开
        window.callJsBridge(
          { action: "open_web", data: { url: el.href } },
          (err, data) => {
            console.log(err, data);
          }
        );
        window.callJsBridge(
          { action: "close", data: { } },
          (err, data) => {
            console.log(err, data);
          }
        );
        return
      }
    });
  }
})
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || 'en', 
  messages: {
    'jp': require('@/i18n/languages/jp.json'),
    'fr': require('@/i18n/languages/fr.json'),
    'en': require('@/i18n/languages/en.json'),
    'de': require('@/i18n/languages/de.json'),
    'sp': require('@/i18n/languages/sp.json'),
  }
});
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')